const es = {
  home: 'Astros ahora',
  calculate: 'Calcular',
  charts: 'Mis cartas',
  my_chart: 'Mi carta',
  calendario: 'Calendario',
  consult_stella: 'Consulta a',
  buscador: 'Buscador',
  compatibility: 'Compatibilidad',
  rectification: 'Rectificación',
  synastry: 'Sinastría',
  composite_chart: 'Carta compuesta',
  select_chart: 'Elegir carta',
  myprofile: 'Mi perfil',
  description: 'este es el cielo ahora.',
  no_results: 'No hay resultados',
  hola: 'Hola',
  newest: 'Más nuevas',
  oldest: 'Más antiguas',
  favoritas: 'Favoritas',
  agregar: 'Agregar',
  search_placeholder: 'Buscar por nombre o apellido',
  editar: 'Editar',
  ver: 'Ver',
  compartir: 'Compartir',
  ShareFooter: 'Calculada con la precisión de Appstral',
  eliminar: 'Eliminar',
  no_cartas: 'Aún no hay cartas',
  no_events: 'No se encontraron eventos de esas características',
  no_favs: 'Aún no tienes cartas favoritas',
  no_favs_sub: 'Destaca a tus tus personalidades favoritas para tenerlas a mano.',
  minuto: 'Minuto',
  hora: 'Hora',
  día: 'Día',
  semana: 'Semana',
  mes: 'Mes',
  año: 'Año',
  años: 'Años',
  planet_now: "{{planet}} a {{degree}}°{{minutes}}' {{retrograde}} de  {{sign}}",
  planet_in_degree:
    "{{planet}} a {{degree}}°{{minutes}}' {{retrograde}} de  {{sign}} en casa {{house}}",
  planet_range_one_sign:
    "{{planet}} desde {{degreeStart}}°{{minutesStart}}' a {{degreeEnd}}°{{minutesEnd}}' de {{signStart}} {{retrograde}}",
  planet_range_two_signs:
    "{{planet}} desde {{degreeStart}}°{{minutesStart}}' de {{signStart}} a {{degreeEnd}}°{{minutesEnd}}' de {{signEnd}} {{retrograde}}",
  ascendant_in_degree: "Ascendente a {{degree}}°{{minutes}}' de  {{sign}}",
  mc_in_degree: "Medio Cielo a {{degree}}°{{minutes}}' de  {{sign}}",
  planets: {
    sol: 'Sol',
    luna: 'Luna',
    mercurio: 'Mercurio',
    venus: 'Venus',
    marte: 'Marte',
    júpiter: 'Júpiter',
    saturno: 'Saturno',
    urano: 'Urano',
    neptuno: 'Neptuno',
    plutón: 'Plutón',
    lilith: 'Lilith',
    quirón: 'Quirón',
    nodo: 'Nodo Norte',
    'nodo norte': 'Nodo Norte',
  },
  signs: {
    aries: 'Aries',
    tauro: 'Tauro',
    géminis: 'Géminis',
    cáncer: 'Cáncer',
    leo: 'Leo',
    virgo: 'Virgo',
    libra: 'Libra',
    escorpio: 'Escorpio',
    sagitario: 'Sagitario',
    capricornio: 'Capricornio',
    acuario: 'Acuario',
    piscis: 'Piscis',
  },
  Mayores: 'Mayores',
  Menores: 'Menores',
  Aspects: {
    conjuncion: 'conjunción',
    semisextil: 'semisextil',
    sextil: 'sextil',
    cuadratura: 'cuadratura',
    trigono: 'trígono',
    quincuncio: 'quincuncio',
    oposicion: 'oposición',
  },
  invalid_year_range:
    'Invalid year range. Years must be between {{min}} and {{max}} and the start year must be before the end year.',
  search_error: 'An error occurred during the search.',
  connection_error: 'Could not connect to the server.',
  astrological_search: 'Buscador Astrológico',
  planet_in_sign: 'Planeta en Signo',
  planet: 'Planeta',
  sign: 'Signo',
  degree: 'Grado',
  optional: '(opcional)',
  motion: 'Movimiento',
  select: 'Seleccionar',
  retrogrado: 'Retrógrado',
  directo: 'Directo',
  planetary_aspects: 'Aspectos planetarios',
  aspect: 'Aspecto',
  aspects: 'Aspectos',
  natal_search_title: 'En carta',
  balance: 'Balance energético',
  natal_chart: 'Carta Natal',
  progressed_chart: 'Carta Progresada',
  natal_planet: 'Planeta Natal',
  solar_revo: 'Revolución Solar',
  draconica: 'Carta Dracónica',
  progressions: 'Progresiones Secundarias',
  transits: 'Tránsitos',
  transit: 'Tránsito',
  solar: 'Solar',
  time_range: 'Rango de tiempo',
  start_year: 'Año inicial',
  end_year: 'Año final',
  search: 'Buscar',
  loading: 'Buscando',
  calculating: 'Calculando',
  results: 'Resultados',
  no_more_results: 'No hay más resultados',
  search_results_count: 'Tu búsqueda arrojó {{count}} resultados',
  loadingData: 'Cargando datos',
  noUserDataFound: 'No se encontraron datos del usuario.',
  personalData: 'Datos personales',
  name: 'Nombre',
  birthDate: 'Fecha de nacimiento',
  birthTime: 'Hora de nacimiento',
  birthCity: 'Ciudad de nacimiento',
  changePassword: 'Cambiar contraseña',
  newPassword: 'Nueva contraseña',
  passwordChangedSuccessfullyAndLoggedOut:
    'Contraseña cambiada exitosamente. Se ha cerrado la sesión.',
  noUserLoggedInOrEmailMissing: 'No hay usuario autenticado o falta el email.',
  requiresRecentLoginPrompt:
    'Por favor, reingrese su contraseña actual para confirmar su identidad.',
  incorrectCurrentPassword: 'Contraseña ingresada incorrecta',
  currentPassword: 'Contraseña actual',
  confirmNewPassword: 'Confirmar nueva contraseña',
  passwordsDoNotMatch: 'Las contraseñas no coinciden.',
  passwordTooShort: 'La contraseña debe tener al menos 6 caracteres.',
  passwordChangedSuccessfully: 'Contraseña cambiada exitosamente.',
  passwordChangeError: 'Error al cambiar la contraseña',
  changePasswordButton: 'Cambiar',
  languageSelection: 'Idioma',
  toggleLanguage: 'Cambiar Idioma',
  english: 'Inglés',
  spanish: 'Español',
  membership: 'Membresía',
  membershipType: 'Tipo de membresía',
  changeHouseSystem: 'Sistema de Casas',
  selectHouseSystem: 'Seleccionar sistema de casas',
  selectAnOption: 'Selecciona una opción',
  pleaseSelectHouseSystem: 'Por favor selecciona un sistema de casas.',
  houseSystemChangedSuccessfully: 'Sistema de casas cambiado exitosamente.',
  houseSystemChangeError: 'Error al cambiar el sistema de casas',
  changeHouseSystemButton: 'Sistema de Casas',
  legal: 'Legales',
  privacyPolicy: 'Política de Privacidad',
  termsAndConditions: 'Términos y Condiciones',
  profile: {
    Placidus: 'Placidus',
    Topocentric: 'Topocéntrico',
    Koch: 'Koch',
    EqualHouses: 'Casas iguales',
    WholeSigns: 'Signos enteros',
    membershipType: 'Tipo de membresía',
    cancelMembership: 'Cancelar mi membresía',
  },
  stellarMember: 'MIEMBRO ESTELAR',
  notAvailable: 'No disponible',
  notYetAMember: '¡Aún no eres miembro!',
  stellarDescription:
    'Tienes acceso a todas las funciones de Appstral Web, y puedes calcular cartas de manera ilimitada.',
  stellarPrice: 'El precio de tu suscripción es de $1 USD al mes',
  solarMember: 'MIEMBRO SOLAR',
  solarDescription: 'Tienes acceso a tu revolución solar y la de todas tus otras cartas.',
  solarPrice: 'El precio de tu suscripción es de $1 USD al mes',
  logout: 'Cerrar sesión',
  deleteAccount: 'Eliminar cuenta',
  Subscribe: 'Subscribirse',

  form: {
    nombre: 'Nombre',
    apellido: 'Apellido',
    fecha_nacimiento: 'Fecha de nacimiento',
    hora_nacimiento: 'Hora de nacimiento',
    select_country: 'Selecciona un pais',
    select_city: 'Selecciona una ciudad',
    select_city_search: 'Busca una ciudad',
    fecha_error_rango: 'Fecha inválida. Revisá día, mes y año (1700–2100).',
    hora_error: 'Hora inválida (00:00 a 23:59).',
    nombre_error: 'El nombre solo puede tener letras, espacios, guiones y apóstrofes.',
    apellido_error: 'El apellido solo puede tener letras, espacios, guiones y apóstrofes.',
  },

  rectificacion: {
    titulo: 'Rectificación',
    subtitulo: 'Encontrá la hora natal más probable a partir de eventos de vida.',
    hora_estimada: 'Hora estimada',
    rango_busqueda: 'Rango de búsqueda',
    eventos: 'Eventos de vida',
    evento_descripcion: 'Descripción del evento',
    evento_categoria: 'Categoría del evento',
    categoria_grupos: {
      vida_muerte: 'Vida / Muerte',
      familia: 'Familia / Vínculos',
      trabajo: 'Trabajo / Carrera',
      salud: 'Salud',
      residencia: 'Residencia',
      educacion: 'Educación',
      logros: 'Logros / Reconocimiento',
      legal: 'Legal / Judicial',
      crisis: 'Crisis / Transformación',
      otros: 'Otros',
    },
    categorias: {
      muerte_padre: 'Muerte del padre',
      muerte_madre: 'Muerte de la madre',
      muerte_hermano: 'Muerte de hermano/a',
      muerte_conyuge: 'Muerte de pareja / cónyuge',
      muerte_hijo: 'Muerte de hijo/a',
      muerte_otro: 'Muerte (otro vínculo)',
      accidente_grave: 'Accidente grave',
      matrimonio: 'Matrimonio',
      separacion: 'Separación / divorcio',
      relacion: 'Relación / noviazgo',
      hijo: 'Nacimiento de hijo/a',
      adopcion: 'Adopción',
      hermano: 'Nacimiento de hermano/a',
      ruptura_familiar: 'Ruptura familiar',
      trabajo: 'Trabajo nuevo',
      ascenso: 'Ascenso',
      despido: 'Despido',
      negocio: 'Negocio propio',
      quiebra: 'Quiebra',
      cambio_carrera: 'Cambio de carrera',
      jubilacion: 'Jubilación',
      diagnostico: 'Diagnóstico',
      operacion: 'Operación',
      accidente: 'Accidente',
      recuperacion: 'Recuperación',
      tratamiento: 'Tratamiento',
      mudanza: 'Mudanza',
      emigracion: 'Emigración',
      compra_casa: 'Compra de casa',
      perdida_hogar: 'Pérdida del hogar',
      estudio: 'Inicio de estudios',
      graduacion: 'Graduación',
      abandono_estudio: 'Abandono de estudios',
      logro_publico: 'Logro público',
      fama: 'Fama',
      fracaso_publico: 'Fracaso público',
      juicio_inicio: 'Inicio de juicio',
      juicio_sentencia: 'Sentencia judicial',
      juicio_ganado: 'Juicio ganado',
      juicio_perdido: 'Juicio perdido',
      condena: 'Condena',
      libertad: 'Liberación / libertad',
      herencia_legal: 'Herencia',
      deuda_legal: 'Deuda legal',
      trauma: 'Trauma',
      fractura: 'Fractura',
      crisis: 'Crisis',
      viaje: 'Viaje',
      conversion: 'Conversión / fe',
      terapia: 'Terapia',
      otro: 'Otro',
    },
    agregar_evento: 'Agregar evento',
    eventos_minimos: 'Cargá al menos 3 eventos nítidos y bien fechados.',
    rectificar: 'Rectificar',
    calculando: 'Calculando',
    volver: 'Volver al formulario',
    error: 'Ocurrió un error al rectificar. Revisá los datos e intentá de nuevo.',
    hora_seleccionada: 'Hora seleccionada',
    score: 'Score',
    hits_angulares: 'Hits angulares',
    historial: 'Últimas rectificaciones',
    historial_vacio: 'Acá van a aparecer tus últimas rectificaciones.',
    reset: 'Limpiar formulario',
    robustez: 'Robustez',
    robusto: 'Resultado nítido',
    ambiguo: 'Resultado ambiguo',
    vs_segunda: 'vs. {{hora}} (Δscore {{diff}})',
    carta_natal: 'Carta natal',
    col_grafico: 'Score por hora',
    leyenda_mejor: 'mejor hora',
    leyenda_seleccionada: 'hora seleccionada',
    leyenda_score: 'score por minuto',
    eje_x: 'hora de nacimiento candidata',
    col_direcciones: 'Direcciones',
    col_speculum: 'Speculum',
    tocan_angulo: '{{n}}/{{total}} tocan ángulo ≤{{dias}} días',
    evento: 'Evento',
    direccion: 'Dirección',
    delta_dias: 'Δdías',
    angulo: 'Angular',
    sin_direccion: 'sin dirección en la ventana',
    punto: 'Punto',
    info: {
      abrir: 'Cómo funciona la rectificación',
      titulo: 'Cómo funciona la rectificación',
      cerrar: 'Cerrar',
      intro:
        'La rectificación estima la hora de nacimiento más probable probando cada hora candidata dentro del rango elegido y puntuando qué tan bien explica cada una los eventos de vida que cargaste.',
      secciones: [
        {
          h: 'Método',
          p: [
            'Appstral usa Direcciones Primarias con la clave de tiempo de Naibod, una de las técnicas predictivas más antiguas y precisas de la astrología, basada en la rotación diurna real del cielo y no en el movimiento de los planetas.',
            'Para cada hora candidata, el motor calcula las direcciones entre todos los planetas y los ángulos de la carta (Ascendente y Medio Cielo) para los cinco aspectos mayores, en movimiento Directo y Converso, usando direcciones zodiacales con latitud.',
          ],
        },
        {
          h: 'Puntuación',
          p: [
            'Cada evento se asocia con su dirección más cercana. El score refleja qué tan lejos cae esa dirección de la fecha real del evento: cuanto más bajo, mejor.',
            'Las direcciones al Ascendente o al Medio Cielo pesan más, porque son los únicos puntos que se desplazan de forma significativa ante pequeños cambios en la hora de nacimiento. Las direcciones que involucran a Saturno, Urano, Neptuno o Plutón también suman peso extra, por su rol histórico al marcar las grandes transiciones de la vida.',
          ],
        },
        {
          h: 'Aciertos angulares',
          p: [
            'El conteo que aparece debajo de la tabla de Direcciones (por ejemplo, 3/5 aciertos angulares ≤30 días) mide cuántos eventos son reproducidos por una dirección al Ascendente o al Medio Cielo dentro de los treinta días de la fecha registrada. Es la señal más confiable de una buena rectificación: las direcciones angulares son especialmente sensibles a la hora exacta de nacimiento.',
          ],
        },
        {
          h: 'Robustez',
          p: [
            'La robustez mide qué tan claramente se separa el mejor candidato del siguiente. Un resultado nítido significa que la mejor hora puntúa bastante mejor que cualquier alternativa. Un resultado ambiguo significa que dos o más horas candidatas rinden parecido, lo que suele requerir más eventos de vida o criterio astrológico para resolverse.',
          ],
        },
        {
          h: 'Cómo interpretar los resultados',
          p: [
            'Un buen resultado suele combinar un score general bajo, varios aciertos angulares en una ventana de tiempo corta y una separación clara respecto de los candidatos cercanos. La tabla del Speculum muestra las coordenadas astronómicas exactas usadas en los cálculos.',
            'La rectificación es una estimación de probabilidad, no una certeza. La calidad del resultado depende directamente de qué tan precisos y biográficamente significativos sean los eventos elegidos.',
          ],
        },
      ],
    },
  },

  movimiento: 'Movimiento',
  retrograde: 'Retrógrado',
  direct: 'Directo',
  searchby: 'Buscar por',
  posicion: 'Posición',
  nueva_carpeta: 'Nueva carpeta',
  nombre_nueva_carpeta: 'Crear carpeta',
  editar_nombre_carpeta: 'Editar carpeta',
  mover_a: 'Mover a',
  quitar_de_carpeta: 'Remover',
  carpeta_vacia_titulo: 'Aquí todavía no hay estrellas',
  carpeta_vacia_sub: 'Crea o mueve una carta a esta carpeta.',
  volver_mis_cartas: 'Volver a Mis cartas',

  alert: {
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    confirm_delete_title: '¿Estás seguro?',
    confirm_delete_message:
      '¿Estás seguro de que quieres eliminar la carta de {{nombre}} {{apellido}}?',
    confirm_delete_folder: '¿Estás seguro de eliminar la carpeta "{{nombre}}"?',
  },

  Policy: {
    title: 'Política de protección de datos',
    introduction:
      "La presente Política de Privacidad describe cómo APPSTRAL (en lo sucesivo, 'APPSTRAL' o 'Plataforma'), recopila, almacena y utiliza la información personal de los usuarios que acceden a la Plataforma.\nAl utilizar la Plataforma, usted acepta los términos establecidos en esta Política de Privacidad y autoriza la recopilación y uso de sus datos personales conforme a lo detallado aquí.\nAPPSTRAL le pide que lea con detenimiento estas Políticas de Privacidad.",
    subtitle1: 'Introducción',
    description1:
      'El término “Datos Personales” se refiere a cualquier información que pueda identificarlo, como su nombre, dirección de correo electrónico, teléfono, dirección postal u otra información de contacto.\nAPPSTRAL garantiza que procesará sus Datos Personales conforme a esta Política de Privacidad y en cumplimiento de la Ley 25.326 de Protección de Datos Personales. No obstante, en casos específicos podríamos procesarlos para cumplir con obligaciones legales, regulatorias o judiciales.',
    subtitle2: '¿Quién es el Responsable del tratamiento de sus datos?',
    description2:
      'El responsable del tratamiento de los datos de índole personal es:\n● Identidad: SITTA TOMÁS RODRIGO\n● DNI:42.876.938\n● CUIT 20-42876938-5\n● Domiciliación fiscal: Molière 683 Piso 1 Depto 1, Ciudad Autónoma de Buenos Aires\n● Correo electrónico: contacto@appstral-soporte.com',
    subtitle3: '¿Qué información se recaba y de dónde?',
    description3:
      'El Usuario, por el hecho de remitir sus datos de carácter personal a través de correo electrónico o rellenando cualquier formulario de la Plataforma, consiente a APPSTRAL su tratamiento conforme a la presente política de protección de datos.\nAl utilizar los servicios ofrecidos por APPSTRAL, se obtienen datos como: fecha, hora y lugar de nacimiento, entre otros, así como datos bancarios para el cobro de la suscripción premium en caso de que la solicite, de acuerdo a nuestros Términos y condiciones de uso.\nNo se recolectan datos sensibles, ni de contacto personal, salvo los estrictamente necesarios para el funcionamiento de la app.',
    subtitle4: '¿Tiempo de conservación de datos?',
    description4:
      'Los datos proporcionados por el usuario se conservarán durante la vigencia de la relación comercial con nuestra compañía, sin perjuicio de que el interesado pueda solicitar la supresión de los mismos.',
    subtitle5: 'Finalidad y licitud del procesamiento de datos',
    description5:
      'Los datos personales recabados por APPSTRAL tienen como finalidad:\n1. Facilitar, agilizar y cumplir con la correcta prestación de los servicios de análisis y generación de cartas astrales ofrecidos a través de la plataforma.\n2. Gestionar las solicitudes, consultas y reclamos realizados por el Usuario.\n3. Informar al Usuario sobre novedades, actualizaciones, promociones y propuestas relacionadas con los servicios de APPSTRAL, a través de medios automatizados o no automatizados (correo electrónico, SMS, notificaciones dentro de la app, entre otros), que consideremos puedan ser de su interés.\n4. Personalizar la experiencia del Usuario, incluyendo la elaboración de perfiles astrológicos basados en la información proporcionada, con el fin de ofrecer interpretaciones y contenidos más adecuados a sus intereses y necesidades.\nEl Usuario reconoce y acepta que la falta de provisión de ciertos datos personales podrá impedir a APPSTRAL prestar de forma adecuada los servicios vinculados a dichos datos.',
    subtitle6: 'Desistimiento del Usuario.',
    description6:
      'El usuario tendrá derecho a desistir en su consentimiento en cualquier momento, debiendo comunicarse el mismo a través de los siguientes medios de contacto:\ncontacto@appstral-soporte.com\nComo regla general, la retirada del consentimiento no condicionará el uso de la Plataforma. En aquellas ocasiones en las que el Usuario deba facilitar sus datos a través de los campos establecidos para realizar consultas, solicitar información o por motivos relacionados con el contenido de la Plataforma, será debidamente informado en caso de que la cumplimentación de alguno de ellos sea obligatoria, esto se dará cuando estos datos sean imprescindibles para el correcto desarrollo de la operación.',
    subtitle7: 'Destinatarios de los datos',
    description7:
      'Los datos personales facilitados por el Usuario no serán comunicados a terceros, salvo que ello sea necesario para la prestación de los servicios solicitados, de lo que será puntualmente informado, o cuando el Usuario hubiera aceptado expresamente su comunicación. Los datos personales podrán ser comunicados a las Administraciones y Organismos Públicos competentes, de conformidad con la legislación vigente y de acuerdo con las obligaciones legales correspondientes.',
    subtitle8: 'Seguridad de los datos personales',
    description8:
      'APPSTRAL se compromete a adoptar las medidas técnicas y organizativas necesarias, según el nivel de seguridad adecuado al riesgo de los datos recogidos, de forma que se garantice la seguridad de los datos de carácter personal y se evite la destrucción, pérdida o alteración accidental o ilícita de datos personales transmitidos, conservados o tratados de otra forma, o la comunicación o acceso no autorizados a dichos datos.\nSin embargo, debido a que APPSTRAL no puede garantizar la seguridad total de internet, ni la ausencia total de “hackers” que accedan de modo fraudulento a los datos personales, el responsable del tratamiento se compromete a comunicar al Usuario, sin dilaciones indebidas, que ha ocurrido una violación de la seguridad de los datos personales, y que sea probable que entrañe un alto riesgo para los derechos y libertades de las personas físicas.',
    subtitle9: 'Menores',
    description9:
      'El acceso, uso y suscripción en la Plataforma están permitidos únicamente para personas mayores de edad y con plena capacidad legal para contratar, conforme a la legislación vigente en el domicilio del Visitante y/o Usuario. Queda expresamente prohibido el acceso, uso, suscripción o navegación por parte de menores de edad. Cualquier incumplimiento de esta disposición constituirá una violación a las presentes Políticas de Privacidad. Los padres, tutores o representantes legales serán responsables de cualquier uso no autorizado de APPSTRAL por parte de menores de edad, así como de los daños que dicho uso pudiera ocasionar tanto al menor como a terceros.\nEl acceso, uso y suscripción en la Plataforma están permitidos únicamente para personas mayores de edad y con plena capacidad legal para contratar, conforme a la legislación vigente en el domicilio del Visitante y/o Usuario. Queda expresamente prohibido el acceso, uso, suscripción o navegación por parte de menores de edad. Cualquier incumplimiento de esta disposición constituirá una violación a las presentes Políticas de Privacidad. Los padres, tutores o representantes legales serán responsables de cualquier uso no autorizado de APPSTRAL por parte de menores de edad, así como de los daños que dicho uso pudiera ocasionar tanto al menor como a terceros.\nEl acceso, uso y suscripción en la Plataforma están permitidos únicamente para personas mayores de edad y con plena capacidad legal para contratar, conforme a la legislación vigente en el domicilio del Visitante y/o Usuario. Queda expresamente prohibido el acceso, uso, suscripción o navegación por parte de menores de edad. Cualquier incumplimiento de esta disposición constituirá una violación a las presentes Políticas de Privacidad. Los padres, tutores o representantes legales serán responsables de cualquier uso no autorizado de APPSTRAL por parte de menores de edad, así como de los daños que dicho uso pudiera ocasionar tanto al menor como a terceros.',
    subtitle10: 'Derechos del Usuario',
    description10:
      'Los Visitantes y/o Usuarios tienen el derecho de acceder, rectificar, actualizar, bloquear o suprimir los Datos Personales que hayan proporcionado a APPSTRAL, ya sea directamente o a través de un tercero. Estos derechos solo pueden ejercerse sobre información que sea considerada dato personal según lo establecido en la Ley Nº 25.326 de Protección de Datos Personales.\nPara ejercer cualquiera de estos derechos, el Visitante deberá enviar un correo electrónico a contacto@appstral-soporte.com, indicando su nombre y apellido, número de DNI, el detalle de su solicitud y los motivos del ejercicio de su derecho.\nUna vez recibida la solicitud, APPSTRAL evaluará su procedencia y notificará al Usuario si su solicitud ha sido aceptada o rechazada. En caso de tratarse de una solicitud de acceso a los datos, el plazo de respuesta será de 10 días hábiles desde la recepción del pedido. Si se trata de una solicitud de rectificación, actualización o supresión, la respuesta se brindará en un plazo de 5 días hábiles.\nDe acuerdo con la Disposición DNPDP N° 10/08, el titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita cada seis meses, salvo que acredite un interés legítimo conforme lo dispuesto en el artículo 14, inciso 3 de la Ley Nº 25.326.\nLa Agencia de Acceso a la Información Pública, en su carácter de Órgano de Control de la Ley Nº 25.326, es la entidad encargada de recibir denuncias y reclamos relacionados con el incumplimiento de la normativa de protección de datos personales en Argentina.',
    subtitle11: 'Enlaces a sitios de terceros',
    description11:
      'La Plataforma puede contener enlaces a sitios web de terceros. APPSTRAL no se responsabiliza por las políticas de privacidad o el contenido de dichos sitios. Se recomienda leer las políticas de privacidad de cada página visitada.',
    subtitle12: 'Modificación de la política de privacidad',
    description12:
      'APPSTRAL se reserva el derecho de modificar su política de confidencialidad y de protección de datos como consecuencia de un cambio legislativo o de modificación de la política de tratamiento informático de los datos. Si se produjera alguna modificación, la información será publicada en esta página, donde podrá tener acceso a la política actual en materia de confidencialidad y protección de datos. En cada caso, la relación con los usuarios se regirá por las normas previstas en el momento preciso en que se accede a la Plataforma.',
  },
  Terms: {
    title: 'Términos y condiciones de uso',
    subtitle1: '1. DATOS IDENTIFICATIVOS DEL PRESTADOR DE SERVICIOS',
    description1:
      'La presente aplicación, denominada APPSTRAL (en lo sucesivo, “APPSTRAL” o “Plataforma”), es desarrollada y operada por SITTA TOMÁS RODRIGO, DNI N° 42.876.938, CUIT N° 20-42876938-5, con domicilio real en Molière 683 Piso 1 Depto 1, Ciudad Autónoma de Buenos Aires, Código Postal 1407, República Argentina.',
    subtitle2: '2. TÉRMINOS Y CONDICIONES DE USO',
    description2:
      '2.1 Estas condiciones generales se aplican a toda relación comercial entre el Usuario y APPSTRAL, salvo acuerdo expreso por escrito.\n2.2 El acceso a esta Plataforma es responsabilidad exclusiva de los Usuarios y supone aceptar los presentes términos y condiciones de uso. Con la aceptación se entiende que el Usuario ha aceptado íntegramente el contrato y que, por tanto, previamente ha leído y entendido todos y cada uno de los términos, obligándose a cumplir todas las especificaciones establecidas en las mismas.\n2.3 El Usuario debe realizar un uso lícito de la presente Página Web y sus servicios de acuerdo a los presentes términos y condiciones de uso y a la legalidad vigente.\n2.4 Asimismo, APPSTRAL podrá modificar unilateralmente los términos y condiciones de uso de esta Página Web mediante su publicación en este aviso legal, y producirán efectos desde el mismo momento de su publicación.\n2.5 Todas las marcas, nombres comerciales o signos distintivos de cualquier clase que aparecen en la Página son propiedad de “APPSTRAL o, en su caso, de terceros que han autorizado su uso, sin que pueda entenderse que el uso o acceso al Portal y/o a los Contenidos atribuya al Usuario derecho alguno sobre las citadas marcas, nombres comerciales y/o signos distintivos, y sin que puedan entenderse cedidos al Usuario ninguno de los derechos de explotación que existen o puedan existir sobre dichos contenidos.',
    subtitle3: '3. SERVICIOS PRESTADOS POR APPSTRAL',
    description3:
      "3.1 El objeto del presente contrato es la prestación de un servicio mediante una herramienta digital destinada al análisis astrológico.\n3.2 “APPSTRAL” es una herramienta digital especializada en el análisis astrológico, diseñada para ofrecer a los usuarios una experiencia completa y precisa en la exploración de su carta natal y otros fenómenos astrales. A través de la aplicación, los usuarios pueden acceder a diversas funcionalidades, entre las cuales se incluyen:\n3.2.1 Visualización de la carta astral: Generación detallada de la carta natal a partir de la fecha, hora y lugar de nacimiento del usuario.\n3.2.2. Cálculo de la revolución solar: Análisis personalizado del llamado 'cumpleaños astrológico', que permite prever tendencias y energías predominantes para el año.\n3.2.3 Visualización del cielo astronómico en tiempo real: Representación interactiva de la posición actual de los cuerpos celestes, brindando una experiencia de observación astronómica directa desde la app.\n3.2.4 Consulta de posiciones planetarias y efemérides: Acceso a datos precisos sobre la ubicación de los planetas y otros cuerpos celestes en distintos momentos.\n3.2.5 Seguimiento de fases lunares y eventos astrales: Información actualizada sobre las fases de la Luna y otros fenómenos relevantes, como eclipses o retrogradaciones planetarias.\n3.3 Para garantizar la máxima precisión en los cálculos astrológicos, APPSTRAL utiliza la licencia oficial de Swiss Ephemeris, proporcionada por www.astro.com, de acuerdo con sus respectivos términos de uso.\n3.4 El Uusario se compromete a utilizar la plataforma de forma responsable, exonerando a “APPSTRAL” de cualquier responsabilidad derivada de un uso inadecuado, erróneo o ilegal de la plataforma Web o la aplicación.",
    subtitle4: 'ENTRADA EN VIGOR DE LAS CONDICIONES GENERALES',
    description4:
      'Las Condiciones Generales entrarán en vigor y serán de aplicación a “APPSTRAL” y al Usuario a partir del momento en que este haga uso de la aplicación, ya que dicho uso implica la aceptación plena y sin reservas de los presentes Términos y Condiciones. En caso de no estar de acuerdo con ellos, se solicita abstenerse de utilizar la aplicación.',
    subtitle5: 'POLÍTICA DE PRIVACIDAD',
    description5:
      '5.1 La política de privacidad contenida en estas Condiciones Generales deberá ser aceptada conjuntamente con ellas. La información que usted proporcione a APPSTRAL es absolutamente necesaria y tiene como finalidad poder prestarle los servicios necesarios para que usted, a través de la plataforma.\n5.2 Los datos requeridos serán tratados conforme a la Ley N° 25.326 de Protección de los Datos Personales (Habeas Data).\n5.3 Asimismo, no se venderán ni se cederán sus datos personales a terceros sin su consentimiento expreso.',
    subtitle6: '6. INFORMACIÓN Y DOCUMENTACIÓN SOLICITADA',
    description6:
      '6.1 Podrán hacer uso de “APPSTRAL” y, por tanto, de los servicios que se ponen a disposición del Usuario, todas aquellas personas físicas o jurídicas que accedan a la Plataforma, se den de alta en la misa y aporten la información solicitada durante el proceso de registro. La presente información se recolecta con objeto de permitir un servicio con más funcionalidades para el usuario final.\n6.2 Adicionalmente, para más información sobre nuestra política de protección de datos y privacidad consulte nuestra Política de Privacidad.',
    subtitle7: '7. MENORES DE EDAD',
    description7:
      'Los menores de edad no pueden utilizar los servicios que APPSTRAL presta a través de la Web, por lo que cualquier solicitud de ingreso como miembro en el APPSTRAL de un menor de dieciocho años (18) será denegada.',
    subtitle8: '8. MODALIDADES DE SERVICIO',
    description8:
      "8.1 APPSTRAL ofrece tres modalidades de servicio:\n8.1.1 Plan Gratuito, el cual incluye:\n● Hasta 5 cartas astrales guardadas en la colección.\n● Revolución solar de la carta propia.\n● Tránsitos planetarios sobre la carta propia.\n● Acceso a Stella con un límite de 5 consultas diarias.\n● Acceso a efemérides generales.\n8.1.2 Plan Solar Member (USD 0,99/mes), el cual incluye todo lo del plan gratuito, más:\n● Revolución solar de cualquier carta de la colección.\n● Tránsitos planetarios sobre cualquier carta de la colección.\n8.1.3 Plan Estelar Member (USD 1,99/mes), el cual incluye todo lo del plan Solar Member, más:\n● Cartas astrales ilimitadas.\n● Acceso ilimitado a Stella.\n● Notificaciones personalizadas de tránsitos.\n● Efemérides personalizadas con interpretación astrológica generada por inteligencia artificial.\n● Progresiones secundarias (disponible en la versión web).\n● Cartas dracónicas (disponible en la versión web).\n8.2 La plataforma cuenta con un sistema de suscripciones que habilita funcionalidades exclusivas para los usuarios premium. Las suscripciones se gestionan a través de las tiendas de aplicaciones desde las que se distribuye APPSTRAL: la App Store de Apple en dispositivos iOS y Google Play en dispositivos Android.\n8.3 El pago de las suscripciones, cuyos costos se detallan en el punto 8.1, se realiza exclusivamente a través de la tienda desde la que el Usuario haya descargado la aplicación —App Store en iOS o Google Play en Android—, siendo Apple o Google, según corresponda, el responsable de la intermediación comercial y del procesamiento del pago. El titular de la aplicación no tiene acceso ni control sobre los datos de pago, sobre el proceso de cobro ni sobre los plazos de acreditación. La gestión, renovación y cancelación de la suscripción se realiza desde la cuenta del Usuario en la tienda correspondiente.\n8.4 En lo relativo a la suscripción del servicio premium, el mismo se activará una vez verificado el correcto registro y pago del mismo, pudiendo ello demorar hasta 48 horas por cuestiones ajenas al titular de la app. En ningún caso podrá exigirse una compensación, reintegro o indemnización por dicha demora.\n8.5. Los Usuarios de APPSTRAL podrán encontrar más información relativa los servicios ofrecidos, así como el precio o comisiones de uso de los mismos accediendo a la sección de 'Membresía' de la Plataforma.",
    subtitle9: '9. OBLIGACIONES',
    description9:
      '9.1 APPSTRAL se obliga a:\n9.1.1 Atender con la mayor diligencia posible todas las consultas que pueda ordenar el Ususario derivadas de la utilización de los servicios ofrecidos.\n9.1.2 Prestar el servicio al Cliente conforme a lo establecido en las presentes condiciones.\n9.1.3 Mantener la plataforma “APPSTRAL” operativa las 24 horas del día, salvo interrupciones temporales por servicios de mantenimiento de la web, problemas técnicos o informáticos como caídas de internet producidas por cualquier causa, ataques informáticos y situaciones análogas que hagan imposible de forma temporal la prestación del servicio, éste se restaurará en cuanto que las incidencias se hayan solventado.\n9.1.4 Notificar cualquier movimiento que “APPSTRAL” pueda considerar sospechoso a efectos de comprometer la seguridad de la cuenta del Usuario, para posterior análisis del mismo.\n9.2 El Usuario se obliga a:\n9.2.1 Comunicar a “APPSTRAL” todos los datos necesarios para el acceso y utilización de los servicios que exijan identificación previa, los cuales deberán ser veraces, actuales y ajustados a la realidad.\n9.2.2 Confirmar la aceptación de las presentes Condiciones Generales dejando marcada la casilla en la aplicación donde invita a aceptar los términos y condiciones de APPSTRAL.\n9.2.3 Hacer un uso adecuado de los Servicios incluidos en la Plataforma APPSTRAL, siempre de conformidad con el ordenamiento jurídico.\n9.2.4 A no llevar a cabo actividad alguna que dificulte o interfiera en el funcionamiento de los Servicios, incluidos en la Plataforma.',
    subtitle10: '10. EXCLUSIONES DE RESPONSABILIDAD',
    description10:
      '10.1 Los servicios ofrecidos a través de la plataforma “APPSTRAL” cumplen con lo dispuesto en el ordenamiento jurídico argentino. “APPSTRAL” no será responsable respecto de aquellos servicios que no se ajusten a las disposiciones legales de otros países a los que pudieran acceder usuarios fuera de Argentina.\n10.2 La Plataforma queda exonerada de cualquier responsabilidad en los siguientes casos:\n10.2.1 Uso indebido de la plataforma “APPSTRAL” por parte del Usuario.\n10.2.2 Daños o pérdidas sufridos como consecuencia de sucesos imprevisibles o inevitables, incluidos, de manera enunciativa pero no limitativa, casos fortuitos o de fuerza mayor.\n10.2.3 Fallos, errores técnicos, accidentes, averías, manipulaciones, interrupciones del servicio u otras incidencias que puedan producirse en equipos o servicios técnicos ajenos a “APPSTRAL”, cuyo correcto funcionamiento sea necesario para la prestación del servicio.\n10.2.4 Indisponibilidad temporal de la plataforma debido a causas de fuerza mayor o a suspensiones técnicas necesarias para el mantenimiento o mejora del servicio.\n10.3 El Usuario será responsable de los daños y perjuicios que pudiera ocasionar a terceros debido a la utilización indebida de los datos proporcionados, incluyendo, de manera no limitativa:\n10.3.1 El uso de datos inexactos, falsos o que no se correspondan con la realidad.\n10.3.2 La utilización por parte de terceros de las credenciales de acceso personales del Usuario.',
    subtitle11: '11. CESIÓN Y SUBROGACIÓN APPSTRAL',
    description11:
      'APPSTRAL si lo considera necesario, podrá ceder o subcontratar los contratos formalizados con los Usuarios  a otras entidades para llevar a cabo el objeto del contrato según lo establecido en las presentes Condiciones Generales.',
    subtitle12: '12. SOPORTE Y RECLAMOS',
    description12:
      '12.1 Para cualquier consulta, inconveniente técnico, reclamo o solicitud de soporte, el Usuario podrá comunicarse a través del correo electrónico:\ncontacto@appstral-soporte.com.\n12.2 Se procurará brindar una respuesta en un plazo razonable, priorizando siempre la asistencia efectiva y oportuna.',
    subtitle13: '13. NOTIFICACIONES Y ACTUALIZACIONES',
    description13:
      'El Usuario podrá optar por recibir o no notificaciones dentro de la aplicación relacionadas con novedades, actualizaciones, alertas y mejoras. Esta preferencia podrá configurarse directamente en el perfil de usuario.',
    subtitle14: '14. PROPIEDAD INTELECTUAL Y MARCA REGISTRADA',
    description14:
      'La marca “APPSTRAL” se encuentra registrada a nombre de SITTA TOMÁS RODRIGO y está protegida por la legislación vigente en materia de propiedad industrial. Todos los contenidos, diseños, interfaces, código fuente, funcionalidades, textos, imágenes, bases de datos y demás elementos que integran “APPSTRAL” son de propiedad exclusiva de su titular, y no podrán ser reproducidos, distribuidos ni utilizados sin su autorización expresa y por escrito.',
    subtitle15: '15. PROTECCIÓN AL CONSUMIDOR',
    description15:
      'APPSTRAL respeta los derechos de los usuarios en su carácter de consumidores, conforme a lo previsto en la Ley N° 24.240 y demás normativa aplicable. Ante cualquier inconveniente, el Usuario podrá recurrir tanto a los canales propios de atención al cliente ofrecidos por la plataforma como a los organismos oficiales de defensa del consumidor.',
    subtitle16: '16. LEGISLACIÓN APLICABLE Y JURISDICCIÓN',
    description16:
      'Los presentes Términos y Condiciones se rigen por la legislación vigente de la República Argentina. Para cualquier controversia que se derive del uso de la aplicación, las partes se someten a la jurisdicción de los tribunales ordinarios con competencia en la Ciudad Autónoma de Buenos Aires, renunciando a cualquier otro fuero que pudiera corresponder.',
  },
  button_label: {
    edit: 'Editar',
    delete: 'Eliminar',
    star: 'Favorito',
    share: 'Compartir',
    details: 'Detalles',
    fast: 'Planetas rápidos',
    rectificar: 'Rectificar',
  },
  elemento: 'Elementos',
  ritmo: 'Ritmos',
  polaridad: 'Polaridades',
  error: {
    ups: '¡Ups!',
    mal: 'Algo salió mal',
    texto:
      'Por favor, vuelve a intentarlo. Si el problema persiste, ponte en contacto con el área de soporte de Appstral.',
    boton: 'Volver al inicio',
  },
  orbes: 'Orbes',
  luminarias: 'Luminarias',
  internos: 'Personales',
  externos: 'Transpersonales',
  otros: 'Otros',
  angulos: 'Ángulos',
  orbInfo:
    'Appstral te permite elegir los grados de orbe para cada aspecto planetario de manera simple y rápida ordenándolos en cinco categorías: Luminarias (Sol y Luna), Personales (Mercurio a Saturno), Transpersonales (Urano, Neptuno, Plutón), Otros (Quirón, Lilith y Nodo Norte) y Ángulos (para los aspectos a cúspides como el Ascendente y el Medio Cielo).',
  suscribeModal: {
    logoAlt: 'Logo de Appstral',
    title: 'Comienza tu proceso de suscripción descargándote la app en tu móvil:',
    appleQrAlt: 'Código QR para Apple App Store',
    androidQrAlt: 'Código QR para Google Play Store',
    descriptionPart1: 'Conviértete en',
    memberHighlight: 'Miembro Estelar',
    descriptionPart2:
      'y pon a tu disposición el software astronómico con mayor precisión del planeta.',
  },
  subscriptionModal: {
    title: '¡Parece que aún no eres miembro!',
    message:
      'Suscríbete por sólo $1 USD desde Appstral móvil y accede a todas las funciones para las cartas astrales.',
    closeBtn: 'Cerrar',
    androidQrAlt: 'Código QR para Android',
    appleQrAlt: 'Código QR para iOS',
    ExtraChartsTitle: '¡Parece que no tienes más cartas disponibles!',
    ExtraChartsSubtitle:
      'Suscríbete por sólo $1 USD desde Appstral móvil y crea cartas astrales ilimitadamente.',
    SubscribeTitle: '¡Descubre el cosmos sin límites!',
    SubscribeSubtitle:
      'Suscríbete por sólo $1 USD desde Appstral móvil y accede a todas nuestras funcionalidades.',
  },

  notPremiumModal: {
    welcomeTitle: '¡Bienvenido!',
    message:
      'Tu inicio de sesión fue exitoso, pero tu cuenta no es premium. ¡Actualiza tu plan para acceder a más funciones!',
    closeButton: 'Cerrar',
  },
  loginPage: {
    forgotPassword: '¿Olvidaste tu contraseña?',
    appstralStarAlt: 'Logo Estrella de Appstral',
    appstralLogoAlt: 'Logo de Appstral Web',
    slogan: 'El cielo en tus manos',
    loginTitle: 'Inicio de Sesión',
    emailPlaceholder: 'Correo electrónico',
    passwordPlaceholder: 'Contraseña',
    notMemberPart1: 'Si no eres miembro,',
    subscribeHere: 'regístrate aquí',
    loginButtonText: 'Ingresar',
    footerCopyright: '© Appstral 2026. Todos los derechos reservados.',
    invalidCredentialsError: 'Credenciales inválidas. Por favor, inténtalo de nuevo.',
    loginError: 'Error al iniciar sesión. Por favor, inténtalo de nuevo más tarde.',
    premiumLoginSuccess: '¡Inicio de sesión exitoso! Eres un miembro premium.',
    aboutLink: 'Sobre Appstral',
  },
  registerModal: {
    title: 'Crear cuenta',
    subtitle: 'Completá tus datos de nacimiento para empezar.',
    noTime: 'Sin hora',
    passwordHint: 'La contraseña debe tener al menos 6 caracteres.',
    submit: 'Registrarme',
    cancel: 'Cancelar',
    loading: 'Creando cuenta',
    emailInUse: 'Ese correo ya está registrado.',
    invalidEmail: 'El formato del correo electrónico es inválido.',
    weakPassword: 'La contraseña debe tener al menos 6 caracteres.',
    genericError: 'Ocurrió un error inesperado. Por favor, intentá de nuevo.',
  },
  aboutModal: {
    title: 'Sobre Appstral',
    intro:
      'Nada nuevo se hace queriendo hacer algo nuevo. Lo nuevo aparece cuando uno responde a lo que pide el presente.',
    sections: [
      {
        heading: 'Cómo empezó',
        paragraphs: [
          'Todo lo que vino antes de Appstral hizo que Appstral pudiera existir: las tablillas cuneiformes de los babilonios, los astrolabios, las efemérides medievales copiadas a mano durante siglos, las primeras computadoras astrológicas de los setenta, cada librería de código abierto. Son las herramientas predecesoras que le dieron vida a esta aplicación, y a las que queremos homenajear siempre desde la admiración y el respeto.',
          'Nos proponemos traer una visión humana de la tecnología. Entre ciencia y religión, la astrología siempre decidió ser una tercera posición. Hoy, entre lo humano y lo robot, creemos que puede encontrarla de nuevo: la tecnología no como reemplazo sino herramienta al servicio de lo humano.',
          'Hubo un año, antes de todo esto, que fue difícil. Y en ese año apareció una verdad incómoda: se puede saber mucho de astrología, enseñarla incluso, y aun así no estar prestándole atención al cielo. No estar habitando los ritmos que el lenguaje astrológico nos invita a vivenciar. Porque la astrología es ante todo un idioma, y como cualquier idioma se aprende practicándolo. No solo con un curso una vez al año, sino con pequeñas consultas cotidianas: saber dónde está la Luna hoy, entender qué tránsito estás atravesando en una semana que no afloja, recordar que una cuadratura puede durar unos días y no la vida entera.',
          'Appstral nació de esa necesidad. La de tener una herramienta a mano, todos los días, más parecida al clima o al calendario que a un software profesional: no para pasar horas adentro, sino para consultar rápido y seguir viviendo un poco más ubicado que antes. En enero de 2025, en Buenos Aires, escribimos las primeras líneas de código para calcular una carta natal. Salió, y eso fue el principio.',
        ],
      },
      {
        heading: 'Lo que queremos que sea',
        paragraphs: [
          'Una aplicación que le sirva al astrólogo profesional con la profundidad que necesita: galería de consultantes, tránsitos, progresiones, revoluciones, búsqueda de efemérides, todo con rigor.',
          'Y al mismo tiempo, una app donde alguien que recién empieza, que solo quiere saber dónde tiene la Luna, encuentre un lugar amable y claro, sin tener que aprender a configurar orbes y sistemas de casas antes de ver una carta.',
          'Los dos públicos en un mismo lugar, con el mismo motor y el mismo cariño puesto en cada detalle.',
        ],
      },
      {
        heading: 'Stella',
        paragraphs: [
          'Stella es la astróloga conversacional de Appstral: una herramienta de curiosidad y de exploración.',
          'De curiosidad para el que recién llega. Poder preguntar, sin saber nada, qué es el Medio Cielo y qué significa tenerlo en tu carta en el signo en que lo tenés.',
          'De alcance para el profesional. Pedirle que liste todas las revoluciones solares pasadas en las que tu ascendente cayó en un signo específico. Pedirle todas las fechas exactas en las que la Luna progresada de un cliente cambió de signo. Buscar en segundos cosas que antes llevaban una tarde con efemérides abiertas.',
          'Stella tiene acceso real al motor de efemérides y al contexto de una carta. Si le preguntás dónde estaba Urano un día específico de 1917, lo calcula. Si le preguntás qué tránsitos te están atravesando hoy, lee tu carta y te responde con eso, no con generalidades. La pensamos como un puente: para que el lenguaje técnico de la astrología llegue traducido al cotidiano, sin perder profundidad.',
          'El encuentro de dos almas en una consulta —ese rato en que alguien te mira a los ojos mientras te comparte su vida a corazón y carta abiertos— es único, e imposible de replicar. Stella no viene a ocupar ese lugar, sino a llegar a los momentos en que ese encuentro no es posible. Es una forma de amplificar el alcance de nuestra alma y la del proyecto, de llegar a lugares y momentos donde nosotros, en persona, no podríamos estar.',
        ],
      },
      {
        heading: 'Quiénes la hacemos',
        paragraphs: [
          'Somos cuatro, y nos conocimos estudiando astrología. Hay quienes leen cartas y dan consultas, quienes pensaron cada detalle visual y quienes escribieron el código. Somos amigos, y nos juntamos a construir esto porque sentimos que se podía hacer distinto.',
          'Las interpretaciones, el glosario y cada palabra astrológica de la aplicación fueron escritas por nosotros. El diseño visual también. El código también. Todo lo que hay en Appstral pasó por nuestras manos, nuestras decisiones y nuestra forma de entender la astrología.',
        ],
      },
      {
        heading: 'Esto sigue',
        paragraphs: [
          'Appstral está en web y en mobile. Es freemium, accesible, y se sostiene gracias a quienes se suman como miembros estelares. Seguimos sumando, corrigiendo, escuchando.',
        ],
      },
    ],
    contact: {
      title: 'Escribinos',
      intro:
        'Todo esto crece gracias a ustedes. Somos un equipo chico y hacemos lo que podemos, así que cada mensaje nos ayuda un montón a mejorar. Un error, una idea, un reclamo, un saludo —lo que sea, contanos. Del otro lado te leemos nosotros.',
      emailPlaceholder: 'Tu correo electrónico',
      subjectPlaceholder: 'Asunto',
      messagePlaceholder: 'Tu mensaje',
      sendButton: 'Enviar',
      sending: 'Enviando',
      success:
        '¡Gracias por escribirnos! Lo leemos con atención. Appstral mejora gracias a mensajes como el tuyo.',
      error: 'Algo salió mal. Probá de nuevo en un momento.',
    },
    thanks: 'Gracias por estar acá.',
    storyLink: 'Nuestra historia',
    suggestionsLink: 'Reclamos y sugerencias',
    closeButton: 'Cerrar',
  },
  forgotPasswordModal: {
    title: 'Restaurar Contraseña',
    instruction:
      'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    sendButton: 'Enviar Correo',
    loading: 'Enviando',
    closeButton: 'Cerrar',
    successMessage:
      '¡Correo de restablecimiento enviado! Revisa tu bandeja de entrada (y la carpeta de spam).',
    userNotFound: 'No hay un usuario registrado con ese correo electrónico.',
    invalidEmail: 'Formato de correo electrónico inválido.',
    genericError:
      'Ha ocurrido un error al intentar enviar el correo. Por favor, inténtalo de nuevo.',
  },
  deleteAccountModal: {
    instructions: 'Para eliminar tu cuenta de forma permanente, debes introducir tu contraseña.',
    passwordPlaceholder: 'Contraseña',
    incorrectPasswordError: 'Contraseña incorrecta',
    cancelButton: 'Cancelar',
    loadingButton: 'Eliminando',
    submitButton: 'Eliminar Cuenta',
  },
  chat: {
    confirmDelete: '¿Estás seguro de que deseas eliminar esta conversación?',
    newConversation: 'Nueva conversación',
    initialTitle: '¿Cómo te puedo asistir?',
    inputPlaceholder: 'Consulta a Stella',
    defaultApiError: 'Lo siento, hubo un error en la respuesta.',
    connectionError:
      'Lo siento, estoy teniendo problemas para realizar los cálculos necesarios en este momento. Por favor, inténtalo de nuevo más tarde.',
    quotaExhaustedBubble:
      'Llegaste a tu límite de Stella por hoy. Mañana vas a tener más, o con Estelar son ilimitadas.',
    quotaInputCta: 'Llegaste a tu límite de hoy — hacete miembro Estelar',
  },
  loadingPhrases: {
    interpreting: 'Interpretando la consulta...',
    positioningPlanets: 'Posicionando planetas...',
    estimatingDates: 'Estimando fechas...',
    verifyingData: 'Verificando los datos...',
    revisingEphemeris: 'Revisando efémerides...',
    adjustingTelescope: 'Ajustando el telescopio...',
    tracingAspects: 'Trazando aspectos...',
  },
  irTienda: 'Ir a la tienda',
  MobileBlock: '¿Estás en un dispositivo móvil?',
  AppBlock: 'Puedes descargar Appstral en ',
  PlayStore: 'Play Store',
  calendar: {
    missingNatalData: 'Completa tu información natal (fecha, hora, ciudad) para ver tus tránsitos.',
    firstCalcWarning: 'El primer cálculo anual puede tardar unos segundos...',
    noTransitsFound: 'No se encontraron tránsitos mayores para el año {{year}}.',
    error: {
      missingData: 'Faltan datos natales (fecha, hora o coordenadas) para calcular los tránsitos.',
      apiFailed:
        'Error: {{error}}. Asegúrate de que el backend de Flask esté corriendo en {{url}}.',
      connectionFailed: 'Fallo la conexión con el servidor de tránsitos. Revisa la URL.',
    },
  },
  months: {
    0: 'ENE',
    1: 'FEB',
    2: 'MAR',
    3: 'ABR',
    4: 'MAY',
    5: 'JUN',
    6: 'JUL',
    7: 'AGO',
    8: 'SEP',
    9: 'OCT',
    10: 'NOV',
    11: 'DIC',
  },
  tooltips: {
    fullTransitPhrase: '{{transitPlanet}} en {{aspect}} a {{natalPlanet}} natal',
    shortTransitPhrase: '{{transitPlanet}} {{aspect}} {{natalPlanet}} natal',
  },
  dates: {
    start: 'Inicio',
    partil: 'Partil',
    partiles: 'Partiles',
    end: 'Fin',
  },
};

export default es;
